<template>
  <div>
    <!-- Vuetify 3 does not centre an overlay's content by itself; the two
         classes are what Vuetify 2's overlay did on its own. `persistent`
         because this one is a loading veil, not something to click away. -->
    <!-- :close-on-back false: Vuetify 3 holds every Back navigation while an
         overlay is open, and a persistent one never closes — so on a page
         still loading, or one whose load failed, Back did nothing at all. -->
    <v-overlay :model-value="!!loading" persistent :close-on-back="false" class="align-center justify-center">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      required: true,
      default: false
    }
  }
}
</script>
